// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iconCss_i1b8s8h6{display:block;}
`, "",{"version":3,"sources":["webpack://./node_modules/@fs/zion-ui/dist/es/avatar/BaseIcon.css"],"names":[],"mappings":"AAAA,kBAAkB,aAAa,CAAC","sourcesContent":[".iconCss_i1b8s8h6{display:block;}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
